import router from '@/router/index'
import _includes from 'lodash/includes'
import * as TimeFormats from '@/constants/TimeFormats'
import { format } from 'date-fns'

import { ALL_APP_ITEM_NAMES } from '@/constants/AppItemNames'

export const state = {}
export const getters = {}
export const actions = {
  async sendOwnerNewOrderEmail({ rootGetters }, newOrder) {
    if (!rootGetters['shop/getShouldSendNewOrderAlerts']) return false
    try {
      let phone = router.currentRoute.params.phone || ''
      let emailData = {
        to: rootGetters['shop/getContactEmail'],
        customerEmail: rootGetters['customer/getCustomerEmail'],
        templateData: {
          storeName: rootGetters['shop/getShopTitle'],
          orderNumber: newOrder.fields['Order #'],
          invoiceURL: `${rootGetters['shop/getShopRoot']}/customer/${phone}/orders/${newOrder.id}`,
          customerName: rootGetters['customer/getCustomerName'],
          customerPhone: rootGetters['customer/getCustomerPhoneFormatted'],
          items: newOrder.items || [],
          total: `$${rootGetters['cart/cartTotal'].toFixed(2)}`,
          newOrder,
          timeOrdered: format(
            newOrder.fields['Time Ordered'],
            TimeFormats.verbalDateAndTimeAt
          ),
          fulfillmentType: rootGetters['cart/isDelivery']
            ? 'Delivery'
            : 'Pickup',
        },
      }
      return emailData
    } catch (error) {
      throw Error(error)
    }
  }, // sendOwnerNewOrderEmail

  async sendGuestOrderReceivedEmail({ rootGetters }, newOrder) {
    if (!rootGetters['shop/getShouldSendCustomerInvoice']) return false
    try {
      let getShopDetail = rootGetters['shop/getShopDetail']
      let phone = router.currentRoute.params.phone || ''
      let fulfillmentType = rootGetters['cart/isDelivery']
        ? 'Delivery'
        : 'Pickup'
      let pickupOrDeliveryInstructions = getShopDetail(
        `${fulfillmentType} Info`
      )
      let generalFulfillmentInstructions = getShopDetail(
        'Fulfillment Instructions'
      )

      let newOrderItems = newOrder.items || []
      let realOrderItems = newOrderItems.filter(
        (i) => !_includes(ALL_APP_ITEM_NAMES, i.Name)
      )
      let numItemsOrdered = 0
      realOrderItems.forEach((i) => (numItemsOrdered += Number(i.quantity)))
      let appOrderItems = newOrderItems.filter((i) =>
        _includes(ALL_APP_ITEM_NAMES, i.Name)
      )

      let emailData = {
        to: rootGetters['customer/getCustomerEmail'],
        from: rootGetters['shop/getContactEmail'],
        templateData: {
          storeName: rootGetters['shop/getShopTitle'],
          title: getShopDetail(
            'Guest Invoice Title',
            'Your Order Has Been Received'
          ),
          orderNumber: newOrder.fields['Order #'],
          invoiceURL: `${rootGetters['shop/getShopRoot']}/customer/${phone}/orders/${newOrder.id}`,
          newOrderURL: `${rootGetters['shop/getShopRoot']}/customer/${phone}/new`,
          customerName: rootGetters['customer/getCustomerName'],
          customerPhone: rootGetters['customer/getCustomerPhoneFormatted'],
          items: newOrderItems,
          numItemsOrdered,
          realOrderItems,
          appOrderItems,
          total: `$${rootGetters['cart/cartTotal'].toFixed(2)}`,
          newOrder,
          paymentInfo: getShopDetail('Payment Info'),
          requirePrepay: rootGetters['shop/getRequirePrepay'],
          timeOrdered: format(
            newOrder.fields['Time Ordered'],
            TimeFormats.verbalDateAndTimeAt
          ),
          fulfillmentType,
          pickupOrDeliveryInstructions,
          generalFulfillmentInstructions,
        },
      }
      return emailData
    } catch (error) {
      throw Error(error)
    }
  }, // sendGuestOrderReceivedEmail
}
